module.exports = __webpack_public_path__ + "img/Compact-FR_Overview-Front_1.0375edbf.jpg";